import { type ComponentProps } from 'react'
import clsx from 'clsx'
import { Slot } from '@radix-ui/react-slot'
import { yStack } from 'ui/src/patterns/stack'
import { type Sprinkles } from 'ui/src/theme/sprinkles.css'
import { type FontSizeProps } from 'ui/src/theme/typography'
import { detailsListItem, detailsListLabel, detailsListRoot, detailsListValue } from './DetailsList.css'

type RootProps = ComponentProps<'ul'> & {
  size?: FontSizeProps
  gap?: Sprinkles['gap']
}
const DetailsListRoot = ({ size = 'xs', gap = 'xxs', className, children, ...props }: RootProps) => {
  return (
    <ul className={clsx(detailsListRoot, yStack({ gap, fontSize: size }), className)} {...props}>
      {children}
    </ul>
  )
}

type ItemProps = ComponentProps<'li'>
const DetailsListItem = ({ className, children, ...props }: ItemProps) => {
  return (
    <li className={clsx(className, detailsListItem)} {...props}>
      {children}
    </li>
  )
}

type LabelProps = ComponentProps<'span'> & {
  asChild?: boolean
}
const DetailsListLabel = ({ className, children, asChild, ...props }: LabelProps) => {
  const Component = asChild ? Slot : 'span'

  return (
    <Component className={clsx(className, detailsListLabel)} {...props}>
      {children}
    </Component>
  )
}

type ValueProps = ComponentProps<'span'>
const DetailsListValue = ({ className, children, ...props }: ValueProps) => {
  return (
    <span className={clsx(className, detailsListValue)} {...props}>
      {children}
    </span>
  )
}

export const DetailsList = {
  Root: DetailsListRoot,
  Item: DetailsListItem,
  Label: DetailsListLabel,
  Value: DetailsListValue,
}
